import type { components } from '../../api/schema';
import { Badge, type Tone } from '../../design';

export type Locker = components['schemas']['Locker'];
export type LockerDetail = components['schemas']['LockerDetail'];
export type LockerStatus = components['schemas']['LockerStatus'];
export type LockerType = components['schemas']['LockerType'];

export const STATUS: Record<LockerStatus, { label: string; tone: Tone }> = {
  unprovisioned: { label: 'Neprovizionat', tone: 'neutral' },
  online: { label: 'Online', tone: 'green' },
  degraded: { label: 'Degradat', tone: 'orange' },
  offline: { label: 'Offline', tone: 'red' },
  maintenance: { label: 'Mentenanță', tone: 'purple' },
};

export const TYPE_LABEL: Record<LockerType, string> = {
  office: 'Birou / curier',
  public: 'Instituție publică',
  hotel: 'Aparthotel',
  car: 'Rent-a-car',
  service: 'Pickup / service',
};

export function StatusBadge({ status }: { status: LockerStatus }) {
  return <Badge tone={STATUS[status].tone}>{STATUS[status].label}</Badge>;
}

/** Culorile pinilor de pe hartă și ale indicatorilor, după stare. */
export const STATUS_COLOR: Record<LockerStatus, string> = {
  unprovisioned: '#728095',
  online: '#138969',
  degraded: '#b97417',
  offline: '#cf4b50',
  maintenance: '#8258bd',
};
